import { groq } from 'next-sanity';
import { z } from 'zod';

import { basicText, SanityBasicText } from './basicText';

export const SanityTableSection = z.object({
  sectionIndex: z.number().optional().nullable(),
  _type: z.literal('tableSection'),
  _key: z.string(),
  theme: z.enum(['light', 'charcoal', 'purple']),
  eyebrow: z.string().optional().nullable(),
  title: z.string().optional().nullable(),
  columnHeaders: z.array(z.string()).optional().nullable(),
  rows: z.array(
    z.object({
      _key: z.string(),
      header: z.string().optional().nullable(),
      cells: z
        .array(
          z.object({
            _key: z.string(),
            content: SanityBasicText.optional().nullable(),
          }),
        )
        .optional()
        .nullable(),
    }),
  ),
});
export type SanityTableSection = z.infer<typeof SanityTableSection>;

export const tableSection = groq`{
  _type,
  _key,
  "theme": coalesce(theme, "light"),
  eyebrow,
  title,
  columnHeaders,
  rows[] {
    _key,
    header,
    cells[] {
      _key,
      content[] ${basicText},
    },
  },
}`;
